<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="secondary">
      <div class="container">
        <b-navbar-brand to="/">
          <svg class="" height="2em" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
              <path d="M0 0h100v100H0z" fill="#FF9800"/>
              <text x="50" y="55" text-anchor="middle" dominant-baseline="middle">
                <tspan fill="#ffffff" font-size="90px">{{ brand.substring(0, 1) }}</tspan>
              </text>
            </g>
          </svg>
          {{ brand }}
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav v-if="authenticated">
            <template v-for="location in locations">
              <b-nav-item-dropdown :key="'nav_location_' + location.id">
                <template slot="button-content">
                  <b-icon icon="house"></b-icon>
                  {{ location.name ? location.name : $t('navbar.house') }}
                </template>
                <b-dropdown-item :to="{ name: 'document.index', query: { location: location.id }}">
                  <b-icon icon="file-earmark"></b-icon>
                  {{ $t('navbar.document') }}
                </b-dropdown-item>
                <b-dropdown-item :to="{ name: 'bulletinboard.index', query: { location: location.id }}">
                  <b-icon icon="book"></b-icon>
                  {{ $t('navbar.bulletinboard') }}
                </b-dropdown-item>
                <b-dropdown-item :to="{ name: 'wifi.index', query: { location: location.id }}">
                  <b-icon icon="wifi"></b-icon>
                  {{ $t('navbar.wifi') }}
                </b-dropdown-item>
              </b-nav-item-dropdown>
              <b-nav-item-dropdown v-for="unit in location.units" :key="'nav_unit_' + unit.id">
                <template slot="button-content">
                  <b-icon icon="door-open"></b-icon>
                  {{ unit.name ? unit.name : $t('navbar.flat') }}
                </template>
                <b-dropdown-group>
                  <b-dropdown-item :href="'https://10.60.'+(location.name == 'Rezidence Atmosfera A' ? 21 : 20 )+'.'+unit.number+':8123/'">
                    <svg class="b-icon bi" viewBox="0 0 500 500" width="1em" height="1em" focusable="false" role="img" aria-label="Home Assistant" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g fill="none" fill-rule="evenodd">
                        <path d="M0 0h500v500H0z" fill="#41BDF5"/>
                        <g transform="translate(52 70)">
                          <mask :id="'b'+ unit.number" fill="#fff">
                            <path d="M44.041 343.222V209.58H9.288a9.333 9.333 0 0 1-6.655-15.876L189.639 3.497c4.517-4.594 11.903-4.657 16.498-.14l.12.12 97.601 98.794V83.974a7.778 7.778 0 0 1 7.778-7.778h32.41a7.778 7.778 0 0 1 7.779 7.778v67.138l41.568 42.618a9.333 9.333 0 0 1-6.682 15.85h-34.886v133.642a7.778 7.778 0 0 1-7.778 7.778H51.819a7.778 7.778 0 0 1-7.778-7.778zm206.393-163.26a15.029 15.029 0 0 0 1.46-6.486c0-8.308-6.71-15.043-14.989-15.043-8.278 0-14.989 6.735-14.989 15.043s6.711 15.044 14.99 15.044c2.314 0 4.505-.527 6.462-1.467l21.518 21.596v20.918l-26.981 27.078v-19.84a15.046 15.046 0 0 0 9.993-14.187c0-8.308-6.711-15.044-14.99-15.044-8.278 0-14.99 6.736-14.99 15.044 0 6.55 4.172 12.122 9.994 14.187v29.868l-24.983 25.073V144.464l20.519-20.592a14.886 14.886 0 0 0 6.462 1.466c8.279 0 14.99-6.735 14.99-15.044 0-8.308-6.711-15.043-14.99-15.043-8.278 0-14.989 6.735-14.989 15.043 0 2.323.524 4.522 1.46 6.486l-18.448 18.515-18.449-18.515a15.029 15.029 0 0 0 1.46-6.486c0-8.308-6.71-15.043-14.989-15.043-8.278 0-14.989 6.735-14.989 15.043 0 8.309 6.711 15.044 14.99 15.044 2.314 0 4.505-.527 6.462-1.466l20.518 20.592v105.16l-35.974-36.104v-28.865a15.046 15.046 0 0 0 9.993-14.187c0-8.309-6.711-15.044-14.99-15.044-8.278 0-14.99 6.735-14.99 15.044 0 6.55 4.172 12.122 9.994 14.187v18.837l-27.98-28.081v-27.863a15.046 15.046 0 0 0 9.993-14.187c0-8.308-6.711-15.044-14.99-15.044-8.278 0-14.99 6.736-14.99 15.044 0 6.55 4.172 12.122 9.994 14.187v32.017l30.907 31.018h-17.77c-2.058-5.843-7.61-10.029-14.137-10.029-8.278 0-14.99 6.735-14.99 15.043 0 8.309 6.712 15.044 14.99 15.044 6.527 0 12.08-4.186 14.137-10.03h27.763l43.04 43.196v75.074l-22.983-23.066v-28.866a15.046 15.046 0 0 0 9.993-14.187c0-8.308-6.711-15.043-14.99-15.043-8.278 0-14.99 6.735-14.99 15.043 0 6.55 4.172 12.122 9.994 14.187v18.837l-33.439-33.558a15.029 15.029 0 0 0 1.461-6.486c0-8.308-6.71-15.043-14.99-15.043-8.278 0-14.989 6.735-14.989 15.043s6.711 15.043 14.99 15.043c2.314 0 4.506-.526 6.462-1.466l33.439 33.559h-17.77c-2.058-5.843-7.61-10.03-14.137-10.03-8.278 0-14.99 6.736-14.99 15.044s6.712 15.043 14.99 15.043c6.527 0 12.079-4.186 14.137-10.029h27.763l27.98 28.081h14.132l28.98-29.083h26.763c2.058 5.842 7.61 10.028 14.137 10.028 8.278 0 14.99-6.735 14.99-15.043s-6.712-15.043-14.99-15.043c-6.527 0-12.079 4.186-14.137 10.029H229.84l-26.91 27.006V305.93l32.049-32.164h51.746c2.058 5.843 7.61 10.029 14.136 10.029 8.279 0 14.99-6.735 14.99-15.043 0-8.309-6.711-15.044-14.99-15.044-6.526 0-12.078 4.186-14.136 10.03H244.97l29.908-30.016v-25.072l21.517-21.596a14.886 14.886 0 0 0 6.463 1.467c8.278 0 14.99-6.736 14.99-15.044s-6.712-15.043-14.99-15.043-14.99 6.735-14.99 15.043c0 2.323.525 4.522 1.461 6.486l-14.451 14.504V148.55a15.046 15.046 0 0 0 9.993-14.187c0-8.309-6.711-15.044-14.99-15.044-8.278 0-14.99 6.735-14.99 15.044 0 6.55 4.172 12.122 9.994 14.187v45.915l-14.452-14.504zM120.987 323.909c-3.311 0-5.996-2.694-5.996-6.017 0-3.323 2.685-6.017 5.996-6.017 3.312 0 5.996 2.694 5.996 6.017 0 3.323-2.684 6.017-5.996 6.017zm43.97-45.13c-3.312 0-5.997-2.694-5.997-6.017 0-3.323 2.685-6.017 5.996-6.017 3.312 0 5.996 2.694 5.996 6.017 0 3.323-2.684 6.017-5.996 6.017zm-51.964-7.02c-3.312 0-5.996-2.694-5.996-6.017 0-3.323 2.684-6.017 5.996-6.017 3.311 0 5.996 2.694 5.996 6.017 0 3.323-2.685 6.017-5.996 6.017zm-4.997-50.144c-3.311 0-5.995-2.694-5.995-6.018 0-3.323 2.684-6.017 5.995-6.017 3.312 0 5.996 2.694 5.996 6.017 0 3.324-2.684 6.018-5.996 6.018zm124.912 7.02c-3.311 0-5.995-2.694-5.995-6.017 0-3.324 2.684-6.018 5.995-6.018 3.312 0 5.996 2.694 5.996 6.018 0 3.323-2.684 6.017-5.996 6.017zm67.952 46.133c-3.31 0-5.995-2.694-5.995-6.017 0-3.324 2.684-6.018 5.995-6.018 3.312 0 5.996 2.694 5.996 6.018 0 3.323-2.684 6.017-5.996 6.017zm-25.981 48.138c-3.312 0-5.996-2.694-5.996-6.017 0-3.323 2.684-6.017 5.996-6.017 3.311 0 5.996 2.694 5.996 6.017 0 3.323-2.685 6.017-5.996 6.017zm27.98-143.412c-3.311 0-5.996-2.695-5.996-6.018s2.685-6.017 5.996-6.017c3.311 0 5.996 2.694 5.996 6.017 0 3.323-2.685 6.018-5.996 6.018zm-32.977-39.113c-3.311 0-5.996-2.694-5.996-6.017 0-3.324 2.685-6.018 5.996-6.018 3.312 0 5.996 2.694 5.996 6.018 0 3.323-2.684 6.017-5.996 6.017zm-39.972-24.07c-3.311 0-5.995-2.693-5.995-6.017 0-3.323 2.684-6.017 5.995-6.017 3.312 0 5.996 2.694 5.996 6.017 0 3.324-2.684 6.018-5.996 6.018zm-63.955 0c-3.31 0-5.995-2.693-5.995-6.017 0-3.323 2.684-6.017 5.995-6.017 3.312 0 5.996 2.694 5.996 6.017 0 3.324-2.684 6.018-5.996 6.018zm-51.963 23.067c-3.311 0-5.996-2.694-5.996-6.017 0-3.324 2.685-6.018 5.996-6.018 3.311 0 5.996 2.694 5.996 6.018 0 3.323-2.685 6.017-5.996 6.017zm37.973 37.107c-3.311 0-5.995-2.694-5.995-6.017 0-3.324 2.684-6.018 5.995-6.018 3.312 0 5.996 2.694 5.996 6.018 0 3.323-2.684 6.017-5.996 6.017zm84.94 3.009c-3.31 0-5.995-2.695-5.995-6.018s2.684-6.017 5.995-6.017c3.312 0 5.996 2.694 5.996 6.017 0 3.323-2.684 6.018-5.996 6.018z" />
                          </mask>
                          <g :mask="'url(#b'+unit.number+')'" fill="#FFF">
                            <path d="M0 0h396v351H0z"/>
                          </g>
                        </g>
                      </g>
                    </svg>
                    {{ $t('navbar.hass') }}
                  </b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'voip.index', query: { unit: unit.id }}">
                    <b-icon icon="voip"></b-icon>
                    {{ $t('navbar.voip') }}
                  </b-dropdown-item>
                  <b-dropdown-item v-if="false" to="/consumption">
                    <b-icon icon="binoculars"></b-icon>
                    {{ $t('navbar.consumption') }}
                  </b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'document.index', query: { units: unit.id, types: 'contract' }}">
                    <b-icon icon="file-earmark"></b-icon>
                    {{ $t('navbar.document') }}
                  </b-dropdown-item>
                  <b-dropdown-item :to="{ name: 'document.index', query: { units: unit.id, types: 'manual'}}">
                    <b-icon icon="book"></b-icon>
                    {{ $t('navbar.manuals') }}
                  </b-dropdown-item>
                </b-dropdown-group>
              </b-nav-item-dropdown>
            </template>
            <b-nav-item-dropdown v-if="false">
              <template slot="button-content">
                <b-icon icon="gear"></b-icon>
                {{ $t('navbar.management') }}
              </template>
              <b-dropdown-item disabled to="/management/reclamations">
                <b-icon icon="exclamation-square"></b-icon>
                {{ $t('navbar.reclamations') }}
              </b-dropdown-item>
              <b-dropdown-item disabled to="/management/chat">
                <b-icon icon="chat-right-dots"></b-icon>
                {{ $t('navbar.chat') }}
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item disabled to="/management/contact">
                <b-icon icon="envelope"></b-icon>
                {{ $t('navbar.contact') }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item :to="{ name: 'weblink.index'}">
              <b-icon icon="link45deg"></b-icon>
              {{ $t('navbar.weblink') }}
            </b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav v-else>
            <b-nav-item :to="{ name: 'login'}">
              <b-icon icon="unlock"></b-icon>
              {{ $t('navbar.login') }}
            </b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav class="ml-auto" v-if="authenticated">
            <b-nav-item-dropdown right>
              <template v-slot:button-content>{{ user.name }}</template>
              <b-dropdown-item :to="{ name: 'profile'}">
                <b-icon icon="person-circle"></b-icon>
                {{ $t('navbar.profile') }}
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item href="#" @click.prevent="logoutButton">
                <b-icon icon="lock"></b-icon>
                {{ $t('navbar.logout') }}
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>

    <router-view/>
  </div>
</template>

<script>
import { brand } from '@/config'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  data () {
    return {
      brand: brand
    }
  },
  created() {
    this.$store.$db().model('locations').fetch()
    this.$store.$db().model('units').fetch()
  },
  computed: {
    locations () {
      // Fetch all locations.
      return this.$store.$db().model('locations').query().with('units').has('units').get()
    },
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    })
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout'
    }),

    async logoutButton () {
      await this.logout()

      this.$router.replace({ name: 'home' })
    }
  },
}
</script>